import { useState } from "react";
import { useNavigate, Navigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";
import { toast } from "sonner";
import { Shield } from "lucide-react";

export default function AdminLogin() {
  const { login, user } = useAuth();
  const [email, setEmail] = useState("admin@htpsportshub.com");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  if (user?.role === "admin") return <Navigate to="/admin" replace />;
  if (user?.role === "staff") return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      if (u.role === "staff") {
        toast.info("Staff detected — redirecting to management console");
        nav("/admin");
      } else if (u.role !== "admin") {
        toast.error("Not an admin account");
      } else {
        toast.success("Welcome, admin");
        nav("/admin");
      }
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-5 py-16" data-testid="admin-login">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-10 h-10 border border-brand-orange/50 flex items-center justify-center brand-orange">
            <Shield size={18} />
          </div>
          <div className="font-mono text-xs uppercase tracking-[0.3em] brand-orange">// Admin ERP</div>
        </div>
        <h1 className="font-display text-4xl md:text-5xl font-black uppercase leading-none tracking-tighter">
          Secure<br /><span className="brand-orange">access</span>.
        </h1>

        <form onSubmit={submit} className="mt-10 space-y-4">
          <input
            type="email" value={email} onChange={(e) => setEmail(e.target.value)}
            placeholder="Admin email" required
            data-testid="admin-email"
            className="w-full bg-transparent border border-white/20 py-3 px-4 text-white placeholder-white/40 focus:outline-none focus:border-brand-orange"
          />
          <input
            type="password" value={password} onChange={(e) => setPassword(e.target.value)}
            placeholder="Password" required
            data-testid="admin-password"
            className="w-full bg-transparent border border-white/20 py-3 px-4 text-white placeholder-white/40 focus:outline-none focus:border-brand-orange"
          />
          <button
            type="submit" disabled={loading}
            data-testid="admin-submit"
            className="w-full bg-brand-orange text-black py-4 font-bold text-sm uppercase tracking-widest hover:glow-orange disabled:opacity-50"
          >
            {loading ? "…" : "Enter ERP"}
          </button>
        </form>
        <div className="mt-6 text-xs font-mono text-white/40 text-center space-y-1">
          <div>Staff members: <Link to="/management/login" className="brand-blue hover:underline">use the management login</Link></div>
        </div>
      </div>
    </div>
  );
}
